import {routes} from '@/lib/routes'
import {AccessRequest} from "@/types/access-request.ts";
import {NotificationWithData} from "@/types/notification.ts";

type NotificationInfo<T> = {eventType: string, referenceId: string, data: T | null};

function getRouteForEventType<T>(notification: NotificationInfo<T>, currentUserIdentityId: string | null | undefined): string | null {
    const {eventType, referenceId} = notification;
    if (eventType.startsWith('ACCESS_REQUEST_')) {
        const request = notification.data as AccessRequest | null;
        // If the referenced request wasn't loaded (fetch failed or request was
        // deleted), fall back to the my-requests list rather than crashing.
        if (!request) return routes.my.requests.list();
        return request.requester.id === currentUserIdentityId || request.beneficiary.id === currentUserIdentityId ?
            routes.my.requests.detail(referenceId) :
            routes.my.approvals.path();
    }
    if (eventType.startsWith('ACCESS_PROFILE_ASSIGNMENT_')) {
        return routes.my.access.withAssignment(referenceId)
    }
    if (eventType.startsWith('FUNCTION_GROUP_REQUEST_')) {
        return routes.my.functionGroupRequests.detail(referenceId)
    }
    if (eventType.startsWith('FUNCTION_GROUP_ASSIGNMENT_')) {
        return routes.my.access.withAssignment(referenceId)
    }
    if (eventType.startsWith('IDENTITY_')) {
        return routes.identityManagement.identities.detail(referenceId)
    }
    if (eventType.startsWith('PROVISIONING_')) {
        return routes.provisioning.tasks.detail(referenceId)
    }
    return null
}

export function getNotificationRoute<T>(notification: NotificationWithData<T> | null, currentUserIdentityId: string | null | undefined): string | null {
    if (!notification?.eventType || !notification.referenceId) return null
    return getRouteForEventType(notification as NotificationInfo<T>, currentUserIdentityId)
}
